import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LayoutMobile = _resolveComponent("LayoutMobile");
    const _component_LayoutPc = _resolveComponent("LayoutPc");
    return _ctx.isMobile ? (_openBlock(), _createBlock(_component_LayoutMobile, {
        key: 0
    }, {
        default: _withCtx(()=>[
                _renderSlot(_ctx.$slots, "default")
            ]),
        _: 3
    })) : (_openBlock(), _createBlock(_component_LayoutPc, {
        key: 1
    }, {
        default: _withCtx(()=>[
                _renderSlot(_ctx.$slots, "default")
            ]),
        _: 3
    }));
}
